import { render } from "./DocumentInfoComponent.vue?vue&type=template&id=4d7fc4b8&scoped=true"
import script from "./DocumentInfoComponent.vue?vue&type=script&lang=js"
export * from "./DocumentInfoComponent.vue?vue&type=script&lang=js"

import "./DocumentInfoComponent.vue?vue&type=style&index=0&id=4d7fc4b8&scoped=true&lang=css"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7fc4b8"]])

export default __exports__